var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { forwardRef } from 'react';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { FixedSizeList } from 'react-window';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import { combineItemsAndGroupHeaders, getAvailableSpaceAndDirection, getDropDownHeight, getFixedPositionStyle, PADDING_SIZE, toolTipForItem, } from '../utils';
import Typography from '@mui/material/Typography/Typography';
import AccurityIcon from '../../icon/components/AccurityIcon';
var DEFAULT_ITEM_HEIGHT = 48;
var DropDown = /** @class */ (function (_super) {
    __extends(DropDown, _super);
    function DropDown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropDown.prototype.render = function () {
        var _a = this.props, name = _a.name, _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.groups, groups = _c === void 0 ? [] : _c, _d = _a.emptyItemsLabel, emptyItemsLabel = _d === void 0 ? 'no records' : _d, _e = _a.itemRenderer, itemRenderer = _e === void 0 ? function (item) { return item; } : _e, _f = _a.displayToolTips, displayToolTips = _f === void 0 ? true : _f, onSelect = _a.onSelect, htmlItemName = _a.htmlItemName, isLoading = _a.isLoading, className = _a.className, style = _a.style, inverted = _a.inverted, fixedPosition = _a.fixedPosition, _g = _a.itemHeight, itemHeight = _g === void 0 ? DEFAULT_ITEM_HEIGHT : _g;
        if (isLoading || !fixedPosition) {
            return null;
        }
        var combinedItems = combineItemsAndGroupHeaders(items, groups);
        var _h = getAvailableSpaceAndDirection(itemHeight, combinedItems.length, fixedPosition), availableSpace = _h.availableSpace, willDisplayDownwards = _h.willDisplayDownwards;
        var dropDownHeight = getDropDownHeight(itemHeight, combinedItems.length, availableSpace);
        var fixedPositionStyle = getFixedPositionStyle(fixedPosition, willDisplayDownwards);
        var tooltipId = "dropdown-" + name + "-tooltip";
        var renderListHeader = function (index, itemStyle, group) { return (React.createElement(ListSubheader, { key: index, style: itemStyle, component: "div", className: classNames('DropDown__groupItem'), disableSticky: true },
            React.createElement(Typography, { noWrap: true },
                React.createElement(AccurityIcon, { iconName: group.icon, fontSize: "small", sx: { marginRight: 1 } }),
                React.createElement("span", null, group.name)))); };
        var renderListItem = function (index, itemStyle, item) { return (React.createElement(ListItem, __assign({ key: index, style: itemStyle, button: true, className: classNames('DropDown__menuItem'), onClick: function () { return onSelect(item); } }, {
            'data-tip': displayToolTips ? toolTipForItem(item) : null,
            'data-for': tooltipId,
            'html-item-name': htmlItemName
        }),
            React.createElement(ListItemText, null,
                React.createElement(Typography, { noWrap: true }, itemRenderer(item))))); };
        var menuItemRenderer = function (itemProps) {
            var top = itemProps.style.top ? itemProps.style.top.toString() : '0';
            itemProps = __assign(__assign({}, itemProps), { style: __assign(__assign({}, itemProps.style), { top: parseFloat(top) + PADDING_SIZE + "px" }) });
            var item = combinedItems[itemProps.index];
            return item.isHeader ?
                renderListHeader(itemProps.index, itemProps.style, item.group) :
                renderListItem(itemProps.index, itemProps.style, item.item);
        };
        // workaround because of padding on the top and bottom in virtualized list
        var innerElementType = forwardRef(function (_a, ref) {
            var innerElmStyle = _a.style, rest = __rest(_a, ["style"]);
            return (React.createElement("div", __assign({ ref: ref, style: __assign(__assign({}, innerElmStyle), { height: parseFloat(innerElmStyle.height) + PADDING_SIZE * 2 + "px" }) }, rest)));
        });
        var renderListItems = function () {
            if (combinedItems.length === 0) {
                return (React.createElement(List, null,
                    React.createElement(ListItem, { disabled: true, className: "DropDown__menuItem DropDown__menuItem--empty" },
                        React.createElement(ListItemText, { primary: emptyItemsLabel }))));
            }
            else {
                return (React.createElement(FixedSizeList, { height: dropDownHeight, width: 'auto', itemSize: itemHeight, itemCount: combinedItems.length, onItemsRendered: function () { return ReactTooltip.rebuild(); }, innerElementType: innerElementType }, menuItemRenderer));
            }
        };
        return (React.createElement("div", { className: classNames('DropDown', className, { inverted: inverted }), style: __assign(__assign({}, fixedPositionStyle), style) },
            renderListItems(),
            displayToolTips && React.createElement(ReactTooltip, { key: "dropdown_tooltip_" + new Date().getTime(), place: "right", className: classNames('accurity-tooltip'), html: true, type: "dark", id: tooltipId })));
    };
    return DropDown;
}(React.Component));
export { DropDown };
export default DropDown;
//# sourceMappingURL=DropDown.js.map